import{defaultTo as r}from"ramda";var a=r("");export{a as emptyByDefault};
